


























import Vue from 'vue';
export default Vue.extend({
  name: 'GestureTapIcon',
  props: {
    width: Number,
    height: Number
  },
  computed: {
    getWidth() {
      return this.width || 24;
    },
    getHeight() {
      return this.height || 24;
    }
  }
});
